import React, { Component } from "react";
import {
	Button,
	Card,
	Col,
	Form,
	Icon,
	Input,
	Row,
	Switch,
	Cascader,
} from "antd";
import Simple from "./Table";
import { connect } from "react-redux";
import { fetchUsers } from "appRedux/actions/Users";

class Users extends Component {
	componentDidMount() {
		this.props.fetchUsers();
	}

	render() {
		return <Simple />;
	}
}

export default connect(null, { fetchUsers })(Users);



// WEBPACK FOOTER //
// ./src/routes/main/Admin/index.js